import { useTranslation } from 'react-i18next';
import './EmptyState.css';

interface EmptyStateProps {
  message?: string;
  icon?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export default function EmptyState({ message, icon, action }: EmptyStateProps) {
  const { t } = useTranslation();

  return (
    <div className="empty-state">
      {icon && <div className="empty-state-icon">{icon}</div>}
      <p className="empty-state-message">{message ?? t('common.noData')}</p>
      {action && (
        <button className="empty-state-action" onClick={action.onClick}>
          {action.label}
        </button>
      )}
    </div>
  );
}
